// getters
export const GET_NETWORK = 'app/GET_NETWORK'
export const GET_MODALS = 'app/GET_MODALS'
export const APP_IS_READY = 'app/APP_IS_READY'
export const SERVICE_WORKER_IS_READY = 'app/SERVICE_WORKER_IS_READY'
export const SHOW_PRELOAD_TOP_BAR_BUTTON = 'app/SHOW_PRELOAD_TOP_BAR_BUTTON'
export const PRELOAD_IS_READY = 'app/PRELOAD_IS_READY'
export const DATA_TO_PRELOAD = 'app/DATA_TO_PRELOAD'
export const PRELOAD_RESSOURCE_STATUS = 'app/PRELOAD_RESSOURCE_STATUS'
export const PRELOAD_RESSOURCES = 'app/PRELOAD_RESSOURCES'
export const PRELOAD_FILE_STATUS = 'app/PRELOAD_FILE_STATUS'
export const PRELOAD_FILES = 'app/PRELOAD_FILES'
export const PRELOADING = 'app/PRELOADING'
export const SHOW_PRELOAD_MODAL = 'app/SHOW_PRELOAD_MODAL'
export const CONSENT_PRELOAD = 'app/CONSENT_PRELOAD'
export const PRELOAD_ENDED = 'app/PRELOAD_ENDED'
export const PRELOAD_SUCCESS = 'app/PRELOAD_SUCCESS'
export const PRELOAD_LOADING = 'app/PRELOAD_LOADING'
export const PRELOAD_ERROR = 'app/PRELOAD_ERROR'
export const NEED_TO_RELOAD_APP = 'app/NEED_TO_RELOAD_APP'
export const DATA_TO_PRELOAD_STRATEGY = 'app/DATA_TO_PRELOAD_STRATEGY'
export const PRELOAD_CONFIGURATION = 'app/PRELOAD_CONFIGURATION'
// mutations
export const SET_NETWORK = 'app/SET_NETWORK'
export const ADD_MODAL = 'app/ADD_MODAL'
export const REMOVE_CURRENT_MODAL = 'app/REMOVE_CURRENT_MODAL'
export const REMOVE_MODAL = 'app/REMOVE_MODAL'
